import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage, visit } from "@hotwired/turbo"
import { deliveryRequest, DELIVERY_ERROR } from "../modules/delivery_request.mjs"

// Dirección de entrega del carrito: autocompletado de Google, mapa y confirmación (POST set_delivery_mode,
// que devuelve el bloque con la cotización). Doc: _docs/features/cart/cart_show.md
export default class extends Controller {
  static targets = ["field", "map", "confirm", "apt", "notes"]
  static values = { storeId: Number, cartId: Number }

  connect() {
    if (typeof google !== "undefined" && google.maps?.places) {
      this.initAutocomplete()
    } else {
      const interval = setInterval(() => {
        if (typeof google !== "undefined" && google.maps?.places) {
          clearInterval(interval)
          this.initAutocomplete()
        }
      }, 100)
      setTimeout(() => clearInterval(interval), 10000)
    }
  }

  initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.fieldTarget, {
      componentRestrictions: { country: "cl" }
    })
    this.autocomplete.setFields(["address_components", "formatted_address", "geometry"])
    this.autocomplete.addListener("place_changed", this.placeChanged.bind(this))
  }

  placeChanged() {
    const place = this.autocomplete.getPlace()
    if (!place.geometry) return

    const components = place.address_components
    const get = (type) => components.find(c => c.types.includes(type))?.long_name || ""

    this.selectedAddress = {
      formatted_address: place.formatted_address,
      street_address: `${get("route")} ${get("street_number")}`.trim(),
      city: get("locality") || get("administrative_area_level_3"),
      state: get("administrative_area_level_1"),
      zip_code: get("postal_code"),
      country: get("country"),
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng()
    }

    // Mostrar mapa + campos extra
    this.mapTarget.style.display = "block"
    this.confirmTarget.style.display = "block"
    this.aptTarget.style.display = "block"
    this.notesTarget.style.display = "block"

    const position = new google.maps.LatLng(this.selectedAddress.latitude, this.selectedAddress.longitude)

    this.map = new google.maps.Map(this.mapTarget, {
      center: position,
      zoom: 16,
      disableDefaultUI: true,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      gestureHandling: "greedy"
    })

    this.marker = new google.maps.Marker({
      map: this.map,
      position: position,
      draggable: true
    })

    this.geocoder = this.geocoder || new google.maps.Geocoder()

    this.marker.addListener("dragend", () => {
      const newPos = this.marker.getPosition()
      this.map.panTo(newPos)

      this.geocoder.geocode({ location: newPos }, (results, status) => {
        if (status === "OK" && results[0]) {
          const place = results[0]
          const components = place.address_components
          const get = (type) => components.find(c => c.types.includes(type))?.long_name || ""

          this.selectedAddress = {
            formatted_address: place.formatted_address,
            street_address: `${get("route")} ${get("street_number")}`.trim(),
            city: get("locality") || get("administrative_area_level_3"),
            state: get("administrative_area_level_1"),
            zip_code: get("postal_code"),
            country: get("country"),
            latitude: newPos.lat(),
            longitude: newPos.lng()
          }

          this.fieldTarget.value = place.formatted_address
        }
      })
    })
  }

  // Un request a la vez (el botón se deshabilita en vuelo); una falla avisa y lo vuelve a habilitar
  async confirmAddress() {
    if (this.confirmTarget.disabled) return
    const data = { mode: "delivery", ...this.selectedAddress, apt: this.aptTarget.value, delivery_notes: this.notesTarget.value }
    this.confirmTarget.disabled = true
    try {
      const stream = await deliveryRequest(`/stores/${this.storeIdValue}/carts/${this.cartIdValue}/set_delivery_mode`, data, { visit })
      if (stream) renderStreamMessage(stream)
    } catch (error) {
      console.error("No se pudo confirmar la dirección", error)
      window.toastr?.error(DELIVERY_ERROR)
    } finally {
      if (this.element.isConnected) this.confirmTarget.disabled = false
    }
  }
}
